import React from 'react'
import "./About.scss"
import TypingEffect from '../Components/Typing Effect/TypingEffect'
import HeroImg from '../Components/Layouts/HeroImg'

const About = () => {
  return (
    <>
      <HeroImg heading = "About Us" text = "Home / About"/>
      <div className="about">
        <div className="about_left">
          <img src="./about.png" alt="" />
        </div>
       <div className="about_right">
        <TypingEffect message={`Welcome to Paltu, your trusted partner in pet health and wellness!
         At Paltu, we understand that your pets are more than just animals—they’re family. That’s why we’re dedicated to providing high-quality veterinary medicines and health products tailored to the unique needs of your beloved companions.

        Our mission is to ensure that every pet receives the care and attention they deserve. From preventive care to specialized treatments, Paltu offers a wide range of products designed to keep your furry, feathery, or scaly friends happy and healthy.

        With a team of experienced professionals and a passion for animal welfare, Paltu is committed to making pet care accessible, reliable, and stress-free. Whether you’re a pet parent, breeder, or veterinarian, we are here to support you every step of the way.

       Choose Paltu—because every pet deserves the best care!` }typingSpeed={30} />
       </div>
      </div>
    </>
  )
}

export default About